import Vue from 'vue'
import VueRouter from 'vue-router'
// 編集画面レイアウト
const LayoutEditor = () => import(/* webpackChunkName: "layout-editor" */ '@/components/layouts/Editor.vue')
// シンプル版編集画面レイアウト
const LayoutEditorSimple = () =>
  import(/* webpackChunkName: "layout-editor-simple" */ '@/components/layouts/EditorSimple.vue')
// 部屋入力
import Room from './modules/room'
// 簡易入力
import Simple from './modules/simple'
// エラー
const Error = () => import(/* webpackChunkName: "page-error" */ '@/components/pages/Error.vue')
// 404
const NotFound = () => import(/* webpackChunkName: "page-notfound" */ '@/components/pages/NotFound.vue')
Vue.use(VueRouter)

const routes = [
  {
    path: ``,
    component: LayoutEditor,
    children: [...Room],
  },
  {
    path: ``,
    component: LayoutEditorSimple,
    children: [...Simple],
  },
  {
    path: `/error`,
    name: 'error',
    component: Error,
    meta: {
      title: 'エラー',
    },
  },
  {
    path: '*',
    name: 'notfound',
    component: NotFound,
    meta: {
      title: '404',
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // ページ遷移時にページスクロールをTOPに設定する
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // ブラウザバック時は元の位置にセット
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

export default router
